import { render, staticRenderFns } from "./DepartmentListField.vue?vue&type=template&id=6fe7c399&"
import script from "./DepartmentListField.vue?vue&type=script&lang=js&"
export * from "./DepartmentListField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fe7c399')) {
      api.createRecord('6fe7c399', component.options)
    } else {
      api.reload('6fe7c399', component.options)
    }
    module.hot.accept("./DepartmentListField.vue?vue&type=template&id=6fe7c399&", function () {
      api.rerender('6fe7c399', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/fields/DepartmentListField.vue"
export default component.exports